
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainLayout from "../layouts/main";
import Header from "../components/common/Header";
import Loader from "../components/common/Loader";
import useTranslation from "next-translate/useTranslation";
import Footer from "../components/common/Footer";
import Services from "../components/common/services";
import PromoBanner from "../components/common/PromoBanner";
const Cookie = () => {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const cookie = t('services:cookie', {}, { returnObjects: true });
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        let appLoading = new Promise((resolve, reject) => {
            setTimeout(resolve, 2000, true);
        });
        Promise.all([appLoading]).then(values => {
            setIsLoading(false);
            setLoaded(true);
        });
    }, []);
    return (<MainLayout title={seo.cookie_page.title} description={seo.cookie_page.description} alternate={'terms-and-condition'} page={'service'}>
            <PromoBanner />
            <Header t={t}/>
            <main className={'services'}>
                <Services data={cookie}/>
            </main>

            <Footer t={t}/>
            <Loader isLoading={isLoading} loaded={loaded}/>
        </MainLayout>);
};
export default Cookie;

    async function __Next_Translate__getStaticProps__19883903612__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cookie-policy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19883903612__ as getStaticProps }
  